import { createSlice } from "@reduxjs/toolkit";
import deactivatePatientApi from "@custom/rtk-apis/patients/deactivatePatient";

const initialState = {
  status:"",
  result:{},
  message:"",
  loading:false,
  error:""
};

const deactivatePatientSlice = createSlice({
  name: "deactivatePatientSlice",
  initialState,
  reducers: {
    closeDeactivatePatientListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deactivatePatientApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deactivatePatientApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.message = payload.message;
      })
      .addCase(deactivatePatientApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deactivatePatientSlice.reducer;
export const { closeDeactivatePatientListModal } = deactivatePatientSlice.actions;
